export * from '@taqueria/protocol/out/types/Contract';
